export const documentStatusReportOptions = [
  {
    id: 'FINALIZED',
    name: 'Finalizado',
  },
  {
    id: 'CANCELED',
    name: 'Anulado',
  },
  {
    id: 'REJECTED',
    name: 'Rechazado',
  },
];